<button
  class="accordion-item"
  [class.accordion-item-open]="ouvert()"
  (click)="ouvert.set(!ouvert())"
>Contacts</button>
@if (ouvert()) {
  <div class="contacts-panel">
    @for (groupe of groupes; track groupe.key) {
      @if (contacts(groupe.key).length) {
        <h4 class="contacts-group-label">{{ groupe.label }}</h4>
        @for (c of contacts(groupe.key); track c.id) {
          <div class="contact-card">
            <strong>{{ c.prenom }} {{ c.nom }}</strong>
            @if (c.email) {
              <a [href]="'mailto:' + c.email" class="contact-line">{{ c.email }}</a>
            }
            @if (c.portable) {
              <a [href]="'tel:' + c.portable" class="contact-line">{{ c.portable }}</a>
            } @else if (c.telephone) {
              <a [href]="'tel:' + c.telephone" class="contact-line">{{ c.telephone }}</a>
            }
          </div>
        }
      }
    }
  </div>
}
